import React, { Component } from 'react';
import { observer } from "mobx-react";
import { makeObservable, observable, action } from 'mobx';
import FiltersStore from "Stores/ProtocolRecords/FiltersStore";
import AppStore from 'Stores/AppStore';
import 'Styles/commonComponents/FiltersPanel/FiltersPanel.scss';
import IconsContainer from "Utils/IconsContainer";
import Popup2 from "Components/Common/Popup2";
import CheckboxWithText from "Components/Common/CheckboxWithText";
import FilterBlockDateTimeRange from "Components/Common/FiltersPanel/FilterBlockDateTimeRange";
import FilterBlockListItems from "Components/Common/FiltersPanel/FilterBlockListItems";

class FiltersPanel extends Component {

    constructor() {
        super();
    }

    render() {
        let descriptionSearchAllMainItemName =
            [
                AppStore.GetIsAllProductModes() || AppStore.isMeeting == false ? "документа" : null
                ,
                AppStore.GetIsAllProductModes() || AppStore.isMeeting == true ? "совещания" : null
            ]
                .filter(it => it != null)
                .join(", ")
            ;

        return (
            <div className="filter-panel">
                <div id="regnum-alias-content">
                    <div>{(AppStore.isMeeting || AppStore.GetIsAllProductModes()) ? 'Рег. №' : 'Рег. № РК/РКПД'}</div>
                    <input
                        id='filter-regnum-alias'
                        placeholder='Введите рег. номер'
                        className='regnum-input-placeholder-color'
                        onChange={action(e => FiltersStore.filtersRender.regNumAlias = e.target.value)}
                        value={FiltersStore.filtersRender.regNumAlias}
                    />
                </div>

                <CheckboxWithText checked={FiltersStore.filtersRender.matchWholeWord}
                    onChange={(checked) => FiltersStore.filtersRender.matchWholeWord = checked}
                    text="Строгое соответствие"
                />

                <FilterBlockListItems
                    title="Операции"
                    listItems={FiltersStore.filtersValues.successTypes}
                    value={FiltersStore.filtersRender.successTypes}
                    setValue={val => FiltersStore.filtersRender.successTypes = val}
                    useSearch={false}
                />

                <FilterBlockListItems
                    title="Пользователи"
                    listItems={FiltersStore.filtersValues.users}
                    value={FiltersStore.filtersRender.userIds}
                    setValue={val => FiltersStore.filtersRender.userIds = val}
                    getRenderStore={() => FiltersStore.renderStore.users}
                    setRenderStore={val => FiltersStore.renderStore.users = val}
                    emptyText="Нет данных"
                    emptySearchText="Совпадений нет"
                />

                <FilterBlockListItems
                    title="Устройства"
                    listItems={FiltersStore.filtersValues.logDeviceInfos.map(it => ({ key: it.deviceCode, value: `${it.deviceCode} (${it.userName})` }))}
                    value={FiltersStore.filtersRender.deviceCodes}
                    setValue={val => FiltersStore.filtersRender.deviceCodes = val}
                    getRenderStore={() => FiltersStore.renderStore.devices}
                    setRenderStore={val => FiltersStore.renderStore.devices = val}
                    emptyText="Нет данных"
                    emptySearchText="Совпадений нет"
                />

                <FilterBlockDateTimeRange
                    title="Дата и время операции"
                    getValueFrom={() => FiltersStore.filtersRender.startDateFrom}
                    setValueFrom={value => FiltersStore.filtersRender.startDateFrom = value}
                    getValueTo={() => FiltersStore.filtersRender.startDateTo}
                    setValueTo={value => FiltersStore.filtersRender.startDateTo = value}
                    getRenderStore={() => FiltersStore.renderStore.dates}
                    setRenderStore={val => FiltersStore.renderStore.dates = val}
                    timeVisible={true}
                    isTop={true}
                    getMinDate={() =>
                        AppStore.GetIsAllProductModes()
                            ? FiltersStore.filtersValues.allProductModesMinValueStartDate
                            : AppStore.isMeeting
                                ? FiltersStore.filtersValues.meetingMinValueStartDate
                                : FiltersStore.filtersValues.docMinValueStartDate}
                />

                {/*
                <div id="search-all-alias-content">
                    <div className="container-flex-row">
                        Поиск по всему:
                        <Popup2
                            moveLeftFromIconPx={100}
                            widthPx={260}
                            isTop={true}
                            textAlignIsLeft={true}
                            popupText={(
                                <div>Поиск возможен по:<br />
                                    - названию события (без конкретизации названия {descriptionSearchAllMainItemName}, ФИО пользователя и т.д.), например: "Добавлен пользователь";<br />
                                    - доп. информации события (название {descriptionSearchAllMainItemName}, ФИО пользователя и т.д.), например: "Иванов И.И.";<br />
                                    - названию ошибки, например: "Ключ безопасности неизвестен";<br />
                                    - рег. № {descriptionSearchAllMainItemName} без даты;<br />
                                    - коду устройства;<br />
                                    - ФИО должностного лица;<br />
                                    - подразделению должностного лица.
                                </div>
                            )}
                        >
                            {IconsContainer.Get('ci-info')}
                        </Popup2>
                    </div>
                    <input id='search-all-alias'
                        onChange={action(e => FiltersStore.filtersRender.searchAtAll = e.target.value)}
                        value={FiltersStore.filtersRender.searchAtAll}
                    />
                </div>
                */}
            </div>
        );
    };
}

export default observer(FiltersPanel);